'use es6';

import { createSelector } from 'reselect';
export const getRecommendationsMap = state => state.recommendations;
const getRecommendationsTopicPreferencesMap = createSelector(getRecommendationsMap, map => map.get('topicPreferences'));
export const getRecommendationsTopicPreference = createSelector(getRecommendationsTopicPreferencesMap, map => map.get('data'));